<template>
    <div class="auth-wrapper auth-cover">
        <div class="auth-inner row m-0">
          <!-- Brand logo-->
          <a class="brand-logo" href="#" ref="piniaStore">
            <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-best-credit-repair-software-logo.png" alt="creditfixrr logo" style="width:180px;">
          </a>
          <!-- /Brand logo-->

          <!-- Left Text-->
          <div class="col-lg-3 d-none d-lg-flex align-items-center p-0" >
            <div class="w-100 d-lg-flex align-items-center justify-content-center">
              <img class="img-fluid w-100" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/Sign%20up-rafiki.svg" alt="multi-steps">
            </div>
          </div>
          <!-- /Left Text-->

          <!-- Register-->
          <div class="col-lg-9 d-flex align-items-center auth-bg px-2 px-sm-3 px-lg-5 pt-3">
            <div class="width-700 mx-auto">
              <div class="bs-stepper register-multi-steps-wizard shadow-none linear">
                <div class="bs-stepper-header px-0" role="tablist">

                  <div class="step" :class="accountTrigger" data-target="#account-details" role="tab" id="account-details-trigger">
                    <button type="button" class="step-trigger" aria-selected="true">
                      <span class="bs-stepper-box">
                        <vue-feather type='home' icon></vue-feather>
                      </span>
                      <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Account</span>
                        <span class="bs-stepper-subtitle">Enter Email & Password</span>
                      </span>
                    </button>
                  </div>

                  <div class="line">
                    <vue-feather type='chevron-right' icon></vue-feather>
                  </div>

                  <div class="step" :class="personalInfoTrigger" data-target="#personal-info" role="tab" id="personal-info-trigger">
                    <button type="button" class="step-trigger" aria-selected="false" disabled="disabled">
                      <span class="bs-stepper-box">
                        <vue-feather type='user' icon></vue-feather>
                      </span>
                      <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Personal</span>
                        <span class="bs-stepper-subtitle">Enter Information</span>
                      </span>
                    </button>
                  </div>

                  <div class="line">
                    <vue-feather type='chevron-right' icon></vue-feather>
                  </div>

                  <div class="step" :class="memberSignup" data-target="#billing" role="tab" id="billing-trigger">
                    <button type="button" class="step-trigger" aria-selected="false" disabled="disabled">
                      <span class="bs-stepper-box">
                        <vue-feather type='award' icon></vue-feather>
                      </span>
                      <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Membership</span>
                        <span class="bs-stepper-subtitle">Membership Type</span>
                      </span>
                    </button>
                  </div>
                </div>

                <div class="bs-stepper-content px-0 mt-4">
                  <div id="account-details" class="content " :class="accountInformation" role="tabpanel" aria-labelledby="account-details-trigger">
                    <div class="content-header mb-2">
                      <h2 class="fw-bolder mb-75">Account Information</h2>
                      <span>Enter your username password details</span>
                    </div>
                    <form novalidate="novalidate" data-rewardful="true">
                      <div class="row">
                        <!-- <div class="col-md-6 mb-1">
                          <label class="form-label" for="username">Username</label>
                          <input type="text" name="username" id="username" class="form-control" placeholder="Username" v-model="name"/>
                          <div v-if="vuelidate.name.$error" class="error">"{{vuelidate.name.$errors[0].$message}}</div>
                          <ErrorHandler :error="userStore.error" keyword="name"/>
                        </div> -->
                        <div class="col-md-6 mb-1">
                          <label class="form-label" for="email">Email</label>
                          <input type="email" name="email" id="email" class="form-control" placeholder="example@email.com" aria-label="john.doe" v-model="email"/>
                          <div v-if="vuelidate.email.$error" class="error"> {{vuelidate.email.$errors[0].$message}} </div>
                          <ErrorHandler :error="userStore.error" keyword="email"/>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 mb-1">
                          <label class="form-label" for="password">Password</label>
                          <div class="input-group input-group-merge form-password-toggle">
                            <input type="password" name="password" id="password" class="form-control" placeholder="············" v-model="password"/>
                            <span class="input-group-text cursor-pointer">
                                <vue-feather type="eye" size="12" />
                            </span>
                          </div>
                          <div v-if="vuelidate.password.$error" class="error">{{vuelidate.password.$errors[0].$message}}</div>
                          <ErrorHandler :error="userStore.error" keyword="password"/>
                        </div>
                        <div class="col-md-6 mb-1">
                          <label class="form-label" for="confirm-password">Confirm Password</label>
                          <div class="input-group input-group-merge form-password-toggle">
                            <input type="password" name="confirm-password" id="confirm-password" class="form-control" placeholder="············" v-model="confirmed">
                            <span class="input-group-text cursor-pointer">
                                <vue-feather type="eye" size="12" />
                            </span>
                          </div>
                          <div v-if="vuelidate.confirmed.$error" class="error">The confirm password value must be equal to the password value</div>
                        </div>

                        <!-- <div class="col-12 mb-1">
                          <label class="form-label" for="multiStepsURL" >Affiliate Link (optional)</label>
                          <input type="text" name="multiStepsURL" id="multiStepsURL" class="form-control" placeholder="johndoe/profile" aria-label="johndoe" v-model="affiliate">
                          <div v-if="vuelidate.affiliate.$error" class="error">{{vuelidate.affiliate.$errors[0].$message}}</div>

                        </div> -->
                      </div>
                    </form>

                    <div class="d-flex justify-content-between mt-2">
                      <button class="btn btn-outline-secondary btn-prev waves-effect d-flex align-items-center" disabled>
                        <vue-feather type='chevron-left' size="14" class="align-middle" />
                        <span class="align-middle d-sm-inline-block d-none">Previous</span>
                      </button>
                      <button class="btn btn-primary btn-next waves-effect waves-float waves-light d-flex align-items-center" v-on:click="nextStep">
                        <span class="align-middle d-sm-inline-block d-none">Next</span>
                        <vue-feather type='chevron-right' size="14"  class="align-middle" />
                      </button>
                    </div>
                  </div>
                  <div id="personal-info" class="content" :class="personInfo" role="tabpanel" aria-labelledby="personal-info-trigger">
                    <div class="content-header mb-2">
                      <h2 class="fw-bolder mb-75">Personal Information</h2>
                      <span>Enter your Information</span>
                    </div>
                    <form novalidate="novalidate">
                      <div class="row">
                        <div class="mb-1 col-md-6">
                          <label class="form-label" for="first-name">First Name</label>
                          <input type="text" name="first-name" id="first-name" class="form-control" placeholder="First Name" v-model="firstName">
                          <div v-if="vuelidate.firstName.$error" class="error ">FirstName field is required.</div>
                          <ErrorHandler :error="userStore.error" keyword="first_name"/>

                        </div>
                        <div class="mb-1 col-md-6">
                          <label class="form-label" for="last-name">Last Name</label>
                          <input type="text" name="last-name" id="last-name" class="form-control" placeholder="Last Name" v-model="lastName"/>
                          <div v-if="vuelidate.lastName.$error" class="error ">LastName field is required.</div>
                          <ErrorHandler :error="userStore.error" keyword="last_name"/>
                        </div>
                        <div class="col-md-6 mb-1">
                            <label class="form-label" for="mobile-number">Mobile number</label>
                            <div  v-if="userStore.app_status">

                                <vue-tel-input
                                    class="form-group"
                                    ref="phone_number"
                                    v-bind:class="!userStore.isValid  ? 'is-invalid' : ''"
                                    v-bind:style="[ userStore.isValid == false ? { borderColor: '#ea5455' } : {}]"
                                    v-model="userStore.phone"
                                    @input="input"
                                    @validate="validate"
                                    v-bind:default-country="userStore.defaultCountry"
                                    :inputOptions="{name: name}"
                                    readonly
                                ></vue-tel-input>
                                <span class="invalid-feedback" role="alert">
                                    <strong>{{ userStore.message }}</strong>
                                </span>

                              </div>
                              <div class="" v-else>

                                <vue-tel-input
                                    ref="phone_number"
                                    v-bind:class="!userStore.isValid  ? 'is-invalid' : ''"
                                    v-bind:style="[ userStore.isValid == false ? { borderColor: '#ea5455' } : {}]"
                                    v-model="userStore.phone"
                                    class="form-group"
                                    @input="input"
                                    @validate="validate"
                                    country="US"
                                    v-bind:default-country="userStore.defaultCountry"
                                    :onlyCountries="['US']"
                                    :inputOptions="{name: name}"
                                    readonly
                                ></vue-tel-input>

                                <span class="invalid-feedback" role="alert" >
                                    <strong>{{ userStore.message }}</strong>
                                </span>


                              </div>

                        </div>

                        <div class="col-6 mb-1">
                          <label class="form-label" for="home-address">Home Address</label>
                          <input type="text" name="home-address" id="home-address" class="form-control" placeholder="Address" v-model="address">
                          <div v-if="vuelidate.address.$error" class="error ">Address field is required.</div>
                        </div>

                        <div class="col-4 mb-1">
                          <label class="form-label" for="area-address">Zipcode</label>
                          <input type="text" name="area-address" id="area-address" class="form-control" placeholder="zipcode" v-model="userStore.zipcode" maxlength="5">
                        </div>

                        <div class="mb-1 col-md-4">
                          <label class="form-label" for="town-city">Town/City</label>
                          <input type="text" name="town-city" id="town-city" class="form-control" placeholder="Town/City" v-model="userStore.cityTown">
                        </div>
                        <div class="mb-1 col-md-4">
                            <label class="form-label" for="state">State</label>
                            <v-select
                                name="states"
                                v-if="statestore.states"
                                placeholder="Select State"
                                v-model="userStore.state"
                                :options="statestore.states"
                            />
                            <div v-if="vuelidate.userStore.state.$error" class="error">State field is required.</div>
                        </div>
                      </div>
                    </form>

                    <div class="d-flex justify-content-between mt-2">
                      <button class="btn btn-primary btn-prev waves-effect waves-float waves-light d-flex align-items-center" @click="prevAccount">
                        <vue-feather type="chevron-left" size="14" />
                        <span class="align-middle d-sm-inline-block d-none">Previous</span>
                      </button>
                      <button class="btn btn-primary btn-next waves-effect waves-float waves-light d-flex align-items-center" @click="nextMemberStep">
                        <span class="align-middle d-sm-inline-block d-none">Next</span>
                        <vue-feather type="chevron-right" size="14" />
                      </button>
                    </div>
                  </div>
                  <div id="billing" class="content" :class="memberType" role="tabpanel" aria-labelledby="billing-trigger"  >
                    <div class="content-header mb-2">
                      <h2 class="fw-bolder mb-75">Select Member Type</h2>
                      <span>Select a Member Type</span>
                    </div>

                    <form novalidate="novalidate">
                      <!-- select plan options -->
                      <div class="row custom-options-checkable gx-3 gy-2">
                        <div class="col-md-4">
                          <input class="custom-option-item-check" type="radio" name="plans" id="selfUser" value="">
                          <label class="custom-option-item text-center p-1" for="selfUser" @click="setMemberShip('diy_user')">
                            <span class="custom-option-item-title h3 fw-bolder">Self User</span>
                            <span class="d-block m-75">Your Are The Creditfixrr! Individual access to fix your own credit!</span>
                          </label>
                        </div>

                        <div class="col-md-4">
                          <input class="custom-option-item-check" type="radio" name="plans" id="famalyUser" value="">
                          <label class="custom-option-item text-center p-1" for="famalyUser" @click="setMemberShip('family')">
                            <span class="custom-option-item-title h3 fw-bolder">Family User</span>
                            <span class="d-block m-75">Fix your credit! Plus Invite up to (3) Friends or Family Members!</span>
                          </label>
                        </div>

                        <div class="col-md-4">
                          <input class="custom-option-item-check" type="radio" name="plans" id="businessUser" value="">
                          <label class="custom-option-item text-center p-1" for="businessUser" @click="setMemberShip('business_user')">
                            <span class="custom-option-item-title h3 fw-bolder">Business User</span>
                            <span class="d-block m-75">Help people fix their credit. Add up to (1,000) Active Clients!</span>
                          </label>
                        </div>
                        <div class="col-md-4">
                            <input class="custom-option-item-check" type="radio" name="plans" id="teamUser" value="">
                            <label class="custom-option-item text-center p-1" for="teamUser" @click="setMemberShip('team_member')">
                                <span class="custom-option-item-title h3 fw-bolder">Team User</span>
                                <span class="d-block m-75">Invited to be a part of a Creditfixrr Business Team? A Virtual Assistant?</span>
                            </label>
                        </div>

                      </div>
                      <!--  -->
                      <div v-if="userStore.memberShowError" class="error mt-1">{{ userStore.memberSignupError }}</div>
                      <ErrorHandler :error="userStore.error" keyword="role"/>
                      <!--  -->
                      <div class="form-group mt-1">
                        <div class="custom-control custom-checkbox">
                            <input class="custom-control-input" type="checkbox" id="terms_and_agreements" name="terms_and_agreements" value="1" tabindex="4" v-model="termsAndAgreements">
                            <label class="custom-control-label" for="terms_and_agreements">
                            I agree to <a href="/termsandconditions">privacy policy &amp; terms</a>
                            </label>
                        </div>
                      <div class="error mt-1" v-if="!termsAndAgreements">{{ userStore.termsAndAgreementsError }}</div>
                      <ErrorHandler :error="userStore.error" keyword="terms_and_agreements"/>
                      <!-- check all errors -->
                      <div v-if="Object.keys(userStore.error).length" class="mt-1">
                        <div v-for="err,index in userStore.error">
                            <div v-for="er,index in err" class="error">
                                {{er}}
                            </div>
                          </div>
                        </div>
                    </div>
                    </form>

                    <div class="d-flex justify-content-between mt-1">
                      <button class="btn btn-primary btn-prev waves-effect waves-float waves-light d-flex align-items-center" @click="prevProfile">
                        <vue-feather type="chevron-left" size="14" />
                        <span class="align-middle d-sm-inline-block d-none">Previous</span>
                      </button>
                      <button class="btn btn-success btn-submit waves-effect waves-float waves-light d-flex align-items-center" @click="createAnAccount" v-if="!userStore.signingUp">
                        <vue-feather type="check" size="12"></vue-feather>
                        <span class="align-middle d-sm-inline-block d-none">{{userStore.Submit}}</span>
                      </button>
                      <button class="btn btn-success btn-submit waves-effect waves-float waves-light d-flex align-items-center" @click="createAnAccount" disabled v-else>
                        <span class="align-middle d-sm-inline-block d-none">{{userStore.Submit}}</span>
                      </button>
                    </div>
                  </div>
                    <h5 class="d-flex align-items-center justify-content-center mt-2">
                        <span>Already have an account?</span>
                        <router-link
                            :to="{ name: 'login' }"
                            class="nav-link d-flex align-items-center"
                        >
                            <span>&nbsp;Sign in instead</span>
                        </router-link>
                    </h5>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
</template>
<script>
import { ref,watch } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email, maxLength, minLength, sameAs, helpers,url  } from '@vuelidate/validators'
import axios from 'axios';
import ErrorHandler from "./ErrorComponent.vue"
import PhoneInputComponent from '../PhoneInputComponent'
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import 'flatpickr/dist/flatpickr.css';
import {useUserStore} from '../../stores/UserStore.js'
import { useStateStore } from '../../stores/StateStore.js'
import vSelect from 'vue-select'

export default{
    name:'RegisterPage',
    components: {
        ErrorHandler,
        PhoneInputComponent,
        VueTelInput,
        vSelect
    },
    setup () {
        const userStore = useUserStore();
        watch(userStore, (valid) => {
            if(userStore.isValid == false){
                userStore.message = 'Not A Valid Number'
            }else{
                userStore.message = ''
            }
        })
        return {
            accountTrigger: ref('active'),
            accountInformation: ref('active dstepper-block'),
            personalInfoTrigger: ref(''),
            personInfo: ref(''),
            memberSignup: ref(),
            memberType: ref(),
            phone_number: ref(),
            userStore,
            statestore: useStateStore(),
            vuelidate: useVuelidate()
        }
    },
    data(){
        return{
            email :'',
            password : '',
            confirmed:'',
            firstName:'',
            lastName:"",
            affiliate:"",
            address:'',
            affiliate:"",
            selectedMembership : '',
            termsAndAgreements:'',
        }
    },

    validations () {
        return {
            email : { required,email },
            password: { required,minLength:minLength(8),maxLength:maxLength(24) },
            confirmed: { required, sameAs:sameAs(this.password)},
            firstName:{ required },
            lastName:{ required },
            address:{ required },
            userStore: {
                state: { required }
            },
            termsAndAgreements:{ required },
            selectedMembership:{ required },
            affiliate:{url}
        }
    },
    created(){
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const ct = require('countries-and-timezones');
        let appStatusRoute = this.$router.resolve({
            name: 'app-status'
        });
        axios.get(appStatusRoute.href)
            .then(({ data }) => {
                if (data.data == true) {
                    this.userStore.app_status = true
                    const country = ct.getTimezone(timezone).countries[0];
                    if (country === "" || !country) {
                        this.userStore.defaultCountry = 'US';
                        return;
                    }
                    this.userStore.defaultCountry = country;
                } else {
                    this.userStore.defaultCountry = 'US';
                }
            });
    },
    mounted(){
    },
    methods:{
        input: function (event, object) {
            if(event.length > 0){
                this.$refs.phone_number.$emit('validate', this.$refs.phone_number.phoneObject);
            }
        },
        validate: function (Object) {
            this.userStore.isValid = true;
            if(Object) {
                this.userStore.isValid = Object.valid;
            }
        },
        createAnAccount(){
            if(this.termsAndAgreements == !true){
                this.userStore.termsAndAgreementsError = 'Please accept agree to privacy policy & terms'
                return false
            }
            if(this.vuelidate.$error <= 0 ){
                let $this = this;
                $this.userStore.signingUp = true
                $this.userStore.Submit = 'Signing Up...'
                const params={
                    email : this.email.toLocaleLowerCase(),
                    password : this.password,
                    password_confirmation :this.confirmed,
                    first_name : this.firstName,
                    last_name : this.lastName,
                    affiliate : this.affiliate,
                    phone : this.userStore.phone,
                    address : this.address,
                    zipcode : this.userStore.zipcode,
                    city : this.userStore.cityTown,
                    state_id: this.userStore.state.id,
                    terms_and_agreements:this.termsAndAgreements,
                    role : this.selectedMembership,
                }
                if(this.selectedMembership != ''){
                    let route = this.$router.resolve({
                        name: 'register'
                    });
                    axios.post(route.href,params).then(({data})=>{
                        $this.userStore.signingUp = false
                        $this.userStore.Submit = 'Sign Up'
                        if(data.data != null){
                            if(data.data.authenticated == true){
                                setTimeout(() => {
                                    window.location.href=data.data.route
                                }, 1000);
                            }
                        }else{
                            $this.userStore.signingUp = false
                            $this.userStore.Submit = 'Sign Up'
                            $this.userStore.error = data.message
                        }
                    }).catch((error) => {
                        $this.userStore.error = this.getError(error)
                        $this.userStore.signingUp = false
                        $this.userStore.Submit = 'Sign Up'
                        return false;
                    });

                }else{
                    this.userStore.memberShowError = true;
                    $this.userStore.signingUp = false
                    $this.userStore.Submit = 'Sign Up'
                    this.userStore.memberSignupError = "Please select a membership "
                }
            }else{
                this.userStore.memberShowError = true;
                this.userStore.signingUp = false
                this.userStore.Submit = 'Sign Up'
                this.userStore.memberSignupError = "Please select a membership "
            }
        },
        getError(error){
            const errorMsg = "";

            if (!error.response) {
                return errorMsg;
            }
            if (error.response.data && error.response.data.errors) {
                return error.response.data.errors;
            }
            return errorMsg;
        },
        nextStep(){
           this.vuelidate.$validate();
           this.isPasswordMatch();
           const email = this.vuelidate.email.$error,
           password = this.vuelidate.password.$error;
           if(!email && !password && this.Match == true){
            if(this.affiliate !=""){
                return false
            }
                this.accountTrigger = 'not-active'
                this.accountInformation = 'not-active'
                this.personalInfoTrigger = 'active'
                this.personInfo = 'active dstepper-block'
                this.vuelidate.$reset();
           }else{
                return false;
           }
        },
        nextMemberStep(){
            this.vuelidate.$validate();
            if(
                this.vuelidate.firstName.$error == false
                &&
                this.vuelidate.lastName.$error == false
                &&
                this.vuelidate.address.$error == false
                &&
                this.vuelidate.userStore.state.$error == false
            ){
                this.personalInfoTrigger = 'not-active'
                this.personInfo = 'not-active'
                this.memberSignup = 'active'
                this.memberType = 'active dstepper-block'
            }
        },
        isPasswordMatch(){
            this.Match = this.password == this.confirmed
        },
        setMemberShip(val){
            this.userStore.memberShowError = false;
            this.selectedMembership = val
        },
        prevProfile(){
            this.personalInfoTrigger = 'active'
            this.personInfo = 'active dstepper-block'
            this.memberSignup = 'not-active'
            this.memberType = 'not-active'
        },
        prevAccount(){
            this.accountTrigger = 'active'
            this.accountInformation = 'active dstepper-block'
            this.personalInfoTrigger = 'not-active'
            this.personInfo = 'not-active'
        }
    }

}
</script>
<style lang="scss">
  @import '~/css/base/plugins/forms/form-validation.css';
  @import '~/css/base/pages/authentication.css';
</style>